import { observer } from 'mobx-react';
import { Component } from 'react';

@observer
export default class Code extends Component {
    render() {
        if (this.props.code !== undefined && this.props.code !== null){
            return (this.getCode())
        }
        else return '';
    }

    getCode(){
        return this.props.code.substr(0,1) ==='[' || this.props.code.length < 10  ? this.props.code :
         this.props.code.substr(0,4)+' '+
         this.props.code.substr(4,2)+' '+
         this.props.code.substr(6,3)+' '+
         this.props.code.substr(9,1)+' '+
         this.props.code.substr(10)
    }
}



// WEBPACK FOOTER //
// ./src/components/Code.js